"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLASSIFY_BEDEK_SYSTEM_PROMPT = void 0;
const CLASSIFY_BEDEK_SYSTEM_PROMPT = (defectsTitles, places, categories) => `Analyze the photo with red markings. Using frequency counts (numbers in parentheses):

1. From Places: ${places}
   Select exactly 3 most relevant locations.

2. From Categories: ${categories}
   Select exactly 3 most relevant categories.

3. From Defects: ${defectsTitles}
   Select exactly 5 critical defects.

4. Pay special attention to red markings:
- Prioritize defects and issues visible in or near red-marked regions
- Use red markings as key indicators of where to focus your analysis
- Consider the pattern and concentration of red marks when assessing severity

Rank based on severity, impact, relevance, and frequency counts.`;
exports.CLASSIFY_BEDEK_SYSTEM_PROMPT = CLASSIFY_BEDEK_SYSTEM_PROMPT;
